module.exports = __webpack_public_path__ + "img/center.ae5cc837.svg";